import { Container, Row, Col } from "react-bootstrap";
import { useState } from "react";
import { toast } from "react-toastify";


function ContactPage() {

    const [formData, setFormData] = useState({
      name: "",
      mobile: "",
      message: ""
    });

    const handleChange = (e) => {
      setFormData({
        ...formData,
        [e.target.name]: e.target.value
      });
    };

    const handleSubmit = async (e) => {
      e.preventDefault();
    
      const data = new FormData();
    
      data.append("name", formData.name);
     
      data.append("mobile", formData.mobile);
      data.append("problem", formData.message);
     
    
      try {
        console.log("Sending FormData...");
    
        await fetch(
          "https://script.google.com/macros/s/AKfycbzXy61EwsF9PP-nGiClj6bgZnaN2xZPAKy_y7I2L6r-X_lokr1DI08RG1eeTYSY7bObUw/exec",
          {
            method: "POST",
            body: data, 
          }
        );
    
       
 
         setTimeout(() => {
          toast.success("Data saved successfully!");
          setFormData({ name: "", mobile: "", message: "" });
        }, 300);
      } catch (error) {
        // 👇 Same logic as your jQuery (even if error, show success)
        toast.error("Failed!");
      }
    };

  return (
    <div style={{ background: "var(--white-off)" ,paddingTop:"75px"}}>

      {/* 🔶 HERO SECTION */}
      <section
        style={{
          background: "var(--saffron-deep)",
          color: "white",
          padding: "60px 0",
          textAlign: "center"
        }}
      >
        <Container>
          <h1 style={{ fontWeight: "800" }}>संपर्क करें</h1>
          <p style={{ marginTop: "10px", fontSize: "1.1rem" }}>
            "समस्या आपकी, संघर्ष मेरा"
          </p>
        </Container>
      </section> 

      {/* 🔷 MAIN CONTENT */}
      <section className="py-5">
        <Container>
          <Row className="g-5">

            {/* LEFT SIDE */}
            <Col lg={5}>
              <div
                style={{
                  background: "var(--white-cream)",
                  padding: "25px",
                  borderRadius: "12px",
                  border: "1px solid var(--saffron-light)"
                }}
              >
                <h3 style={{ color: "var(--saffron-dark)" }}>
                  संपर्क जानकारी
                </h3>

                <div className="mt-4" style={{ color: "#333" }}>
                  <p>
                    <strong>📍 स्थान:</strong><br />
                    बरवर नगर पंचायत
                  </p>

                  <p>
                    <strong>🕒 जनता दरबार:</strong><br />
                    प्रतिदिन शाम 7:00 बजे से रात 10:00 बजे तक
                  </p>

                  <p>
                    <strong>📢 संदेश:</strong><br />
                    हर नागरिक की समस्या का समाधान हमारी प्राथमिकता है।
                  </p>
                </div>

                {/* Highlight */}
                <div
                  className="mt-4"
                  style={{
                    background: "var(--saffron-soft)",
                    padding: "15px",
                    borderLeft: "4px solid var(--saffron-deep)",
                    borderRadius: "8px"
                  }}
                >
                  <p style={{ margin: 0, color: "var(--saffron-dark)" }}>
                    सीधे संपर्क करें और अपनी समस्या साझा करें।
                  </p>
                </div>
              </div>
            </Col>

            {/* RIGHT SIDE FORM */}
            <Col lg={7}>
              <div
                style={{
                  background: "var(--white-pure)",
                  padding: "25px",
                  borderRadius: "12px",
                  border: "1px solid var(--saffron-light)"
                }}
              >
                <h3 style={{ color: "var(--saffron-dark)" }}>
                  संदेश भेजें
                </h3>

                <form className="mt-4" onSubmit={handleSubmit}>

                  <div className="mb-3">
                    <label className="form-label">नाम</label>
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="अपना नाम"
                      style={{ borderColor: "var(--saffron-light)" }}
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">मोबाइल नंबर</label>
                    <input
                      type="text"
                      name="mobile"
                      className="form-control"
                      value={formData.mobile}
                      onChange={handleChange}
                      placeholder="मोबाइल नंबर"
                      maxLength={10}
                      style={{ borderColor: "var(--saffron-light)" }}
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">संदेश</label>
                    <textarea
                      rows="4"
                      name="message"
                      className="form-control"
                      value={formData.message}
                      onChange={handleChange}
                      placeholder="अपनी समस्या लिखें"
                      style={{ borderColor: "var(--saffron-light)" }}
                    ></textarea>
                  </div>

                  <button
                    type="submit"
                    className="btn w-100"
                    style={{
                      background: "var(--saffron-deep)",
                      color: "#fff",
                      fontWeight: "600",
                      padding: "10px",
                      borderRadius: "8px"
                    }}
                  >
                    संदेश भेजें
                  </button>
                </form>
              </div>
            </Col>

          </Row>
        </Container>
      </section>

      {/* 🔶 FOOTER STRIP */}
      <section
        style={{
          background: "var(--saffron-dark)",
          color: "white",
          padding: "20px",
          textAlign: "center"
        }}
      >
        <p style={{ margin: 0 }}>
          © जनसेवा के लिए समर्पित — पंडित धीरेंद्र कुमार शर्मा
        </p>
      </section>

    </div>
  );
}

export default ContactPage;